import {
  Button,
  Col,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import {
  useCreateOrUpdateProductMutation,
  useGetProductDetailQuery,
} from "../../services/product";
import { ArrowLeftOutlined, EditOutlined, SearchOutlined } from "@ant-design/icons";
import { Product } from "../../types/product";
import { useEffect, useState } from "react";
import GenericDrawer from "../drawer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useCreateOrUpdateFunctionMutation,
  useDeleteFunctionByIdMutation,
  useGetFunctionByProductIdQuery,
} from "../../services/function";
import { Descriptions } from "antd";
import type { DescriptionsProps } from "antd";
import ProductForm from "../product_management/forms/createUpdateProductForm";
import { Function } from "../../types/function";
import FunctionForm from "./forms/addFunctionForm";
import MonoCell from "../mono-cell";


interface SearchParams {
  product_id?: string;
  function_name?: string;
  function_type?: string;
  indentifier?: string;
  data_type?: string;
  data_transfer_type?: string;
}

const ProductDetailContent = () => {
  const { id ,state} = useParams();
  const navigate = useNavigate();
    const location = useLocation();

  const [form] = Form.useForm();
  // const {
  //   data: product,
  //   error,
  //   isLoading: isLoadingProduct,
  // } = useGetProductDetailQuery(id, {
  //   skip: !id,
  // });
  const [product, setProduct] = useState(location.state || null);

  const { data: allFunction } = useGetFunctionByProductIdQuery({
    productId: id || "",
  });
  const [deleteFunction] = useDeleteFunctionByIdMutation();
  const handleClickDeleteFunction = (id: string) => {
    deleteFunction(id);
  };
  const [createOrUpdateProduct, { data: createOrUpdateProductData }] =
    useCreateOrUpdateProductMutation();
  const [createOrUpdateFunction, { data: createOrUpdateFunctionData }] =
    useCreateOrUpdateFunctionMutation();
  const [messageApi, contextHolder] = message.useMessage();

  const [isDrawerProductVisible, setIsDrawerProductVisible] = useState(false);
  const [isDrawerFunctionVisible, setIsDrawerFunctionVisible] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [selectedFunction, setSelectedFunction] = useState<Function | null>(
    null
  );
  const [searchParams, setSearchParams] = useState<{
    product_id?: string;
    function_name?: string;
    function_type?: string;
    indentifier?: string;
    data_type?: string;
    data_transfer_type?: string;
  } | null>(null);

  const openDrawerProduct = (record: Product | null) => {
    setSelectedProduct(record);
    setIsDrawerProductVisible(true);
  };
  const openDrawerFunction = (record: Function | null) => {
    setSelectedFunction(
      record
        ? record
        : {
            _id: undefined as any,
            dp_id: getDpIdMax(),
            function_name: undefined as any,
            remark: undefined as any,
            indentifier: undefined as any,
            function_type_name: "Property",
            function_type_detail: undefined as any,
            data_type: "Value",
            data_transfer_type: "Send and Report",
            display_type: "Not Display",
            createdAt: undefined as any,
            updatedAt: undefined as any,
          }
    );
    setIsDrawerFunctionVisible(true);
  };

  const closeDrawerProduct = () => {
    setIsDrawerProductVisible(false);
  };
  const closeDrawerFunction = () => {
    setIsDrawerFunctionVisible(false);
  };

  const handleSubmitUpdateProduct = async (values: Product) => {
    values._id = selectedProduct?._id!;
    await createOrUpdateProduct(values);
    closeDrawerProduct();
  };
  const handleSubmitCreateOrUpdateFunction = async (values: Function) => {
    values._id = selectedFunction?._id!;
    const {
      data_transfer_type,
      data_type,
      dp_id,
      function_name,
      function_type_name,
      indentifier,
      _id,
      remark,
      display_type,
      ...function_type_detail
    } = values;
    const dataSubmit = {
      product_id: id,
      data_transfer_type,
      data_type,
      function_name,
      function_type_name,
      indentifier,
      remark,
      dp_id,
      _id,
      display_type,
      function_type_detail,
    };
    await createOrUpdateFunction(dataSubmit);
    closeDrawerFunction();
  };

  const checkDpIdExists = (dpId: number, initDpIp?: number) => {
    // Nếu initDpIp được cung cấp và dpId trùng với initDpIp thì trả về false
    if (initDpIp !== undefined && dpId === initDpIp) {
      return false;
    }
    // Kiểm tra xem dpId có tồn tại trong allFunction không
    return allFunction?.some((item) => item.dp_id === dpId) ?? false;
  };

  const getDpIdMax = () => {
    if (!allFunction || allFunction.length === 0) {
      return 1; // Nếu không có function nào, trả về 1
    }
    const dpIds = allFunction.map((item) => item.dp_id);
    return Math.max(...dpIds) + 1; // Trả về giá trị lớn nhất cộng thêm 1
  };
  const handleSearch = (values: any) => {
    const filteredValues: SearchParams = {
      function_name: values.function_name || undefined,
      function_type: values.function_type || undefined,
      indentifier: values.indentifier || undefined,
      data_type: values.data_type || undefined,
      data_transfer_type: values.data_transfer_type || undefined,
    };
    const hasSearchCriteria = Object.keys(filteredValues).some(
      (key) => filteredValues[key as keyof SearchParams] !== undefined
    );
    setSearchParams(hasSearchCriteria ? filteredValues : null);
  };
  const handleResetForm = () => {
    form.resetFields();
    setSearchParams(null);
  };
  const [dataSource, setDataSource] = useState<Function[]>([]);

  useEffect(() => {
    if (!allFunction) {
      setDataSource([]);
      return;
    }

    if (!searchParams) {
      setDataSource(allFunction);
      return;
    }

    // Filter data on client side
    const filtered = allFunction.filter((item) => {
      if (searchParams.function_name && !item.function_name.toLowerCase().includes(searchParams.function_name.toLowerCase())) {
        return false;
      }
      if (searchParams.function_type && item.function_type_name !== searchParams.function_type) {
        return false;
      }
      if (searchParams.indentifier && item.indentifier !== searchParams.indentifier) {
        return false;
      }
      if (searchParams.data_type && item.data_type !== searchParams.data_type) {
        return false;
      }
      if (searchParams.data_transfer_type && item.data_transfer_type !== searchParams.data_transfer_type) {
        return false;
      }
      return true;
    });
    setDataSource(filtered);
  }, [allFunction, searchParams]);

  useEffect(() => {
    if (createOrUpdateProductData) {
      setProduct(createOrUpdateProductData);
      messageApi.success("Thay mới sản phẩm thành công");
    }
  }, [createOrUpdateProductData, messageApi]);

  useEffect(() => {
    if (createOrUpdateFunctionData) {
      messageApi.success("Thay mới function thành công");
    }
  }, [createOrUpdateFunctionData, messageApi]);
  const columns = [
    {
      title: "DP ID",
      dataIndex: "dp_id",
      key: "dp_id",
      render: (val: number) => <MonoCell>{val}</MonoCell>,
    },
    {
      title: "Tên function",
      dataIndex: "function_name",
      key: "function_name",
    },
    {
      title: "Loại Function",
      dataIndex: "function_type_name",
      key: "function_type_name",
    },
    {
      title: "Identifier",
      dataIndex: "indentifier",
      key: "indentifier",
      render: (text: string) => <MonoCell>{text}</MonoCell>,
    },
    {
      title: "Data type",
      dataIndex: "data_type",
      key: "data_type",
    },
    {
      title: "Data Transfer Type",
      dataIndex: "data_transfer_type",
      key: "data_transfer_type",
    },
    {
      title: "Data Definition",
      dataIndex: "function_type_detail",
      key: "function_type_detail",
      render: (functionTypeDetail: any, record: Function) => {
        if (!functionTypeDetail) return "N/A"; // Trường hợp không có dữ liệu
        const { data_type } = record;
        if (data_type === "Value") {
          const { value_range_min, value_range_max, pitch, scale, unit } =
            functionTypeDetail;
          if (
            value_range_min === undefined ||
            value_range_max === undefined ||
            pitch === undefined ||
            scale === undefined ||
            unit === undefined
          ) {
            return "N/A";
          }
          return `Value Range: ${value_range_min}-${value_range_max}, Pitch: ${pitch}, Scale: ${scale}, Unit: ${unit}`;
        }
        if (data_type === "Double" || data_type === "Float") {
          const { value_range_min, value_range_max, pitch, unit } =
            functionTypeDetail;
          if (
            value_range_min === undefined ||
            value_range_max === undefined ||
            pitch === undefined ||
            unit === undefined
          ) {
            return "N/A";
          }
          return `Value Range: ${value_range_min}-${value_range_max}, Pitch: ${pitch}, Unit: ${unit}`;
        }
        if (data_type === "String") {
          const { string_value } = functionTypeDetail;
          if (string_value === undefined) {
            return "N/A";
          }
          return `Value: ${string_value}`;
        }
        if (data_type === "Fault") {
          const { err_detail } = functionTypeDetail;
          if (err_detail === undefined) {
            return "N/A";
          }
          return `Err detail: ${err_detail}`;
        }
        if (data_type === "Enum") {
          const { enumerated_value } = functionTypeDetail;
          if (
            !Array.isArray(enumerated_value) ||
            enumerated_value.length === 0
          ) {
            return "N/A";
          }
          return `Enum Value: ${enumerated_value
            .map((item) => item.value)
            .join(", ")}`;
        }

        return "N/A";
      },
    },

    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "",
      key: "action",
      render: (record: Function) => (
        <Space size="middle">
          <Button onClick={() => openDrawerFunction(record)}>Cập nhật</Button>
          <Popconfirm
            title="Xoá sản phẩm"
            description="Bạn có chắc chắn xoá Function này"
            onConfirm={() => handleClickDeleteFunction(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Button danger>Xoá</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  if (!product) {
    return null; // Hoặc component thông báo empty state
  }
  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "PID",
      children: product.pid,
    },
    {
      key: "2",
      label: "Device Type",
      children: product.device_type,
    },
    {
      key: "3",
      label: "Protocol",
      children: product.protocol_type,
    },
    {
      key: "4",
      label: "Created At",
      children: new Date(product.createdAt).toLocaleString(),
    },
    {
      key: "5",
      label: "Last Updated",
      children: new Date(product.updatedAt).toLocaleString(),
    },
  ];
  // if (isLoadingProduct) {
  //   return <Spin size="large" />;
  // }

  const optionDataType = [
    { value: "1", label: "Value" },
    { value: "2", label: "Float" },
    { value: "3", label: "Double" },
    { value: "4", label: "String" },
    { value: "5", label: "Date" },
    { value: "6", label: "Bool" },
    { value: "7", label: "Enum" },
    { value: "8", label: "Raw" },
    { value: "9", label: "Array" },
    { value: "10", label: "Fault" },
  ];
  const optionDataTransferType = [
    { value: "Send and Report", label: "Send and Report" },
    { value: "Report Only", label: "Report Only" },
    { value: "Send Only", label: "Send Only" },
  ];
  const optionFunctionType = [
    { value: "1", label: "Property" },
    { value: "2", label: "Event" },
    { value: "3", label: "Action" },
  ];
  const optionIndentifier = allFunction?.map((element, index) => { return { value: element.indentifier, label: element.indentifier } });

  return (
    <div className="container">
      {contextHolder}
      <GenericDrawer
        width={600}
        visible={isDrawerProductVisible}
        onClose={closeDrawerProduct}
        title="Thêm mới sản phẩm"
        formComponent={ProductForm}
        formProps={{
          initialValues: selectedProduct,
          onSubmit: handleSubmitUpdateProduct,
        }}
      />
      <Descriptions
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <ArrowLeftOutlined
              onClick={() => {
                navigate(-1);
              }}
              style={{ marginRight: "8px", fontSize: "18px", color: "#08c" }}
            />
            <span>{product.product_name}</span>
            <Button onClick={() => openDrawerProduct(product)} type="link">
              Edit <EditOutlined style={{ fontSize: "12px" }} />
            </Button>
          </div>
        }
        items={items}
      />
      <div></div>
      <div style={{ marginBottom: "40px" }}>
        <div style={{ float: "right" }}>
          <Button onClick={() => openDrawerFunction(null)}>
            Thêm Function
          </Button>
          <GenericDrawer
            width={600}
            visible={isDrawerFunctionVisible}
            onClose={closeDrawerFunction}
            title="Thêm mới Function"
            formComponent={FunctionForm}
            formProps={{
              initialValues: selectedFunction,
              onSubmit: handleSubmitCreateOrUpdateFunction,
              open: isDrawerFunctionVisible,
              checkDpIdExists: checkDpIdExists,
            }}
          />
        </div>
      </div>
      {/* <div className="search_product">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSearch}>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item name="function_name">
                <Input placeholder="Tên function" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="function_type">
                <Select
                  placeholder="Loại function"
                  allowClear
                  style={{ width: "100%" }}
                  showSearch
                   optionFilterProp="label"
                  options={optionFunctionType}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="indentifier">
                <Select
                  placeholder="Indentifier"
                  allowClear
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  options={optionIndentifier}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>

            <Col span={6}>
              <Form.Item name="data_type">
                <Select
                  placeholder="Data type"
                  allowClear
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  options={optionDataType}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="data_transfer_type">
                <Select
                  placeholder="Data transfer type"
                  allowClear
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  options={optionDataTransferType}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item wrapperCol={{ span: 16 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                >
                  Tìm kiếm
                </Button>
                <Button
                  style={{ marginLeft: "20px" }}
                  // onClick={handleClickResetFormSearch} 
                  onClick={handleResetForm}
                >
                  Làm mới
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div> */}
       <Table columns={columns} dataSource={dataSource} rowKey="_id" />
    </div>
  );
};
export default ProductDetailContent;
